import type { NavItemKey } from "./navActiveMatchers"

export type SiteNavItem = { key: NavItemKey; to: string }

/** Общие разделы публичного сайта: одинаковы для гостя и для любой роли. */
export const SITE_NAV_ITEMS: SiteNavItem[] = [
  { key: "catalog", to: "/catalog" },
  { key: "events", to: "/events" },
  { key: "deposits", to: "/deposits" },
  { key: "news", to: "/news" },
  { key: "writers", to: "/writers" },
  { key: "about", to: "/about" },
]

const ADMIN_NAV_ITEM: SiteNavItem = { key: "admin", to: "/admin" }

/** Основная nav хедера: публичные пункты + «Админка» последней при правах librarian. */
export const buildSiteNavItems = (showAdmin: boolean): SiteNavItem[] =>
  showAdmin ? [...SITE_NAV_ITEMS, ADMIN_NAV_ITEM] : SITE_NAV_ITEMS
